import React, { useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';

const adres = "https://api.pth-hokej.pl";

const FormWrapper = styled.div`
  max-width: 700px;
  margin: 2rem auto;
  background-color: #fdfdfd;
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.08);
`;

const Label = styled.label`
  display: block;
  margin-bottom: 10px;
  font-weight: 600;
  color: #333;
`;

const Select = styled.select`
  width: 100%;
  padding: 12px;
  margin-bottom: 20px;
  border-radius: 8px;
  border: 1px solid #ccc;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px;
  margin-bottom: 20px;
  border-radius: 8px;
  border: 1px solid #ccc;
`;

const TextArea = styled.textarea`
  width: 100%;
  height: 120px;
  padding: 12px;
  margin-bottom: 20px;
  border-radius: 8px;
  border: 1px solid #ccc;
  resize: vertical;
`;

const Button = styled.button`
  background-color: #5e0078;
  color: white;
  padding: 12px 24px;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  width: 100%;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    background-color: #45015c;
  }
`;
const idsWithTitle = ['wprowadzenie', 'opis']; // tu możesz dodać inne id, przy których ma się pokazać tytuł

export const TextEditorForm = () => {
  const [selectedId, setSelectedId] = useState('');
  const [tytul, setTytul] = useState('');
  const [tresc, setTresc] = useState('');

  const handleSelectChange = async (e) => {
    const newId = e.target.value;
    setSelectedId(newId);

    if (newId) {
      try {
        const res = await axios.get(`${adres}/api/teksty/${newId}`);
        setTresc(res.data.tresc || '');
        setTytul(res.data.tytul || '');
      } catch (err) {
        console.error('❌ Błąd przy pobieraniu tekstu:', err);
        setTresc('');
        setTytul('');
      }
    } else {
      setTresc('');
      setTytul('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedId || !tresc) {
      alert('Uzupełnij wymagane pola.');
      return;
    }

    // Jeśli pole tytułu jest widoczne, wysyłamy je; jeśli nie, pomijamy
    const dataToSend = { tresc, tytul: tytul || '' };
    if (idsWithTitle.includes(selectedId)) {
      dataToSend.tytul = tytul;
    }

    try {
      await axios.put(`${adres}/api/teksty/${selectedId}`, dataToSend);
      alert('✅ Tekst został zapisany.');
    } catch (error) {
      console.error('❌ Błąd podczas zapisu:', error);
      alert('Wystąpił błąd podczas zapisu tekstu.');
    }
  };

  return (
    <FormWrapper>
      <form onSubmit={handleSubmit}>
        <Label>Wybierz identyfikator tekstu</Label>
        <Select value={selectedId} onChange={handleSelectChange} required>
          <option value="">-- Wybierz --</option>
          <option value="wprowadzenie">Kim jesteśmy? (strona główna)</option>
          <option value="opis">Kim jesteśmy (kim jesteśmy)</option>
          <option value="historia">Nasza historia (kim jesteśmy)</option>
          <option value="naszewartosci">Nasze wartości (kim jesteśmy)</option>
          <option value="jakdolaczyc">Jak do nas dołączyć (kim jesteśmy)</option>
       
        </Select>

        {/* Pole tytułu tylko gdy wybrany id jest w tablicy */}
        {idsWithTitle.includes(selectedId) && (
          <>
            <Label>Tytuł</Label>
            <Input
              type="text"
              value={tytul}
              onChange={(e) => setTytul(e.target.value)}
            />
          </>
        )}

        <Label>Treść</Label>
        <TextArea
          value={tresc}
          onChange={(e) => setTresc(e.target.value)}
          required
        />

        <Button type="submit">Zapisz tekst</Button>
      </form>
    </FormWrapper>
  );
};